import { colors } from '@chegg-ui/theme'
import { StyledLink } from '@src/components/base/Link'
import styled from 'styled-components'

export const Footer = styled.footer`
  background-color: ${colors.white};
  position: relative;
  border-top: 1px solid ${({ theme }) => theme.colors.greyLight};
  display: flex;
  justify-content: space-between;
`

export const Copyright = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey};
  padding: 10px 20px;
  float: left;
`

export const LinksContainer = styled.div`
  display: flex;
  align-items: center;
`

export const PrivacyLink = styled(StyledLink)`
  color: ${({ theme }) => theme.colors.grey};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  text-decoration: none;
  font-size: ${({ theme }) => theme.font.text.size.xs};
  padding: 10px 20px;
  &:hover {
    color: ${({ theme }) => theme.colors.grey};
    background: transparent;
    text-decoration: underline;
  }
`

export const CCPALink = styled(StyledLink)`
  &#ot-sdk-btn.ot-sdk-show-settings {
    color: ${({ theme }) => theme.colors.grey};
    font-weight: ${({ theme }) => theme.font.weight.medium};
    text-decoration: none;
    &:hover {
      color: ${({ theme }) => theme.colors.grey};
      background: transparent;
      text-decoration: underline;
    }
    font-size: ${({ theme }) => theme.font.text.size.xs};
    border-top: none;
    border-bottom: none;
    border-left: none;
    border-right: none;
    float: right;
    padding: 10px 20px;
  }
`



// WEBPACK FOOTER //
// ./src/components/Footer/styled.ts